import React from 'react';
import Card from '../Card';
import Btn, { btnTypes } from '../../../../../../components/btn';
import {
  RoomComments,
  useRoomCommentsQuery,
} from '../../../../../../components/RoomComments';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';

const emptyArr = [];

const queryOptions = { staleTime: 10 * 1000 };

const CommentsCard = ({ room }) => {
  return (
    <Card>
      <RoomComments hasModal addressId={room?.id} queryOptions={queryOptions}>
        <Card.Header title="Комментарии" />
        <Content />
      </RoomComments>
    </Card>
  );
};

export default CommentsCard;

const COMMENTS_SIZE = 4;
function Content() {
  const { data, isFetching, refetch } = useRoomCommentsQuery();

  const renderedComments = Array.isArray(data)
    ? data.slice(0, COMMENTS_SIZE)
    : emptyArr;

  return (
    <>
      <FetchDataWrapper
        data={data}
        isFetching={isFetching}
        refetch={refetch}
        errMsg="Не удалось загрузить комментарии"
      >
        <Card.Body>
          {renderedComments.map((comment) => (
            <RoomComments.CommentCard
              key={comment.id}
              comment={comment}
              bg="#f3f7fc"
            />
          ))}
        </Card.Body>
      </FetchDataWrapper>
      {Array.isArray(data) && <Action commentsSize={data?.length ?? 0} />}
    </>
  );
}

const OpenModalBtn = RoomComments.createOpenModal(Btn);

function Action({ commentsSize }) {
  return (
    <Card.Action>
      <OpenModalBtn type={btnTypes.primaryInvert} block>
        {commentsSize > COMMENTS_SIZE
          ? `Показать все комментарии (${commentsSize})`
          : 'Добавить комментарий'}
      </OpenModalBtn>
    </Card.Action>
  );
}
